module.exports = __webpack_public_path__ + "img/hellix_double.1e99f511.png";